import React from "react";

import comingsoon from "../../../Assets/coming-soon.svg";

const ApiSettings = () => {
  return (
    <div className="bg-white rounded-lg border border-gray-200 p-12 flex items-center justify-center mt-8">
      <img src={comingsoon} alt="Coming Soon" className="w-[300px] h-auto md:w-[700px]" />
    </div>
  );
};

export default ApiSettings;
